<script>
    import Button from "../../ui_elements/Button.svelte";
    import { generateRandomPassword } from "./admin-utility";
    import PizZip from 'pizzip';
    import Docxtemplater from 'docxtemplater';
    import PageBox from "../../layouts/PageBox.svelte";
    import ContentBox from "../../layouts/ContentBox.svelte";
    import { pop } from 'svelte-spa-router';
    import { post } from "../../utility.js";

    let pageTitle = "Klassenregistrierung";
    let description = "Mehrere neue Nutzer anlegen.";

    let baseUsername = "";
    let userCount = 1;
    let guidedMode = false;
    let ausbildungenOnly = false;
    
    let information = "";
    let users = [];
    let loading = false;

    async function generateUsers() {
        if (userCount <= 0 || userCount > 100) {
            information = "Die Anzahl der Benutzer muss zwischen 1 und 100 liegen.";
            return;
        }
        users = [];
        let preliminaryUsers = [];
        for (let i = 1; i <= userCount; i++) {
            preliminaryUsers.push({
                nr: i,
                name: `${baseUsername}${i}`,
                authcode: generateRandomPassword()
            });
        }

        try {
            loading = true;
            const response = await post('register-class/', { 
                users: preliminaryUsers, 
                guided_mode: guidedMode,
                ausbildungen_only: ausbildungenOnly,
            });
            loading = false;

            users = preliminaryUsers;
            information = "";

        } catch (err) {
            loading = false;
            console.log(err);
            information = err.response.data.error;
            users = [];
        }
    }

    async function exportUsersAsWord() {
        const response = await fetch('/userlist_template.docx');
        if (!response.ok) {
            throw new Error('Failed to load template file');
        }
        const content = await response.arrayBuffer();

        const zip = new PizZip(content);
        const doc = new Docxtemplater(zip, { paragraphLoop: true, linebreaks: true });

        const data = { users };

        doc.render(data);

        const blob = doc.getZip().generate({
            type: 'blob',
            mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            compression: 'DEFLATE',
        });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Nutzerliste_${baseUsername}.docx`;
        link.click();
        URL.revokeObjectURL(link.href);
    }
</script>

<PageBox {pageTitle} {description}>  

    <ContentBox w="1/3" minWidth = "300px">    

    {#if information != ""}
        <div class="mb-4 p-4 bg-accent-light border border-accent-border text-accent-text rounded">
            {information}
        </div>
    {/if}

    <div class="mb-6">
        <label for="baseUsername" class="block text-sm font-medium leading-6">Basis-Username</label>
        <input id="baseUsername" bind:value={baseUsername} placeholder="Basis-Username für die neuen Nutzer" type="text" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent-border sm:text-sm sm:leading-6">
        <p>Aktuell werden die Nutzernamen so aussehen: {baseUsername}1, {baseUsername}2, {baseUsername}3, ...</p>
        <p>Authentifizierungscodes werden für jeden neuen Nutzer automatisch erzeugt und können zusammen mit den Nutzernamen als Word-Dokument heruntergeladen werden.</p>
    </div>

    <div class="mb-6">
        <label for="userCount" class="block text-sm font-medium leading-6">Anzahl der Nutzer</label>
        <input id="userCount" bind:value={userCount} type="number" min="1" max="100" placeholder="Anzahl der Nutzer (1-100)" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent-border sm:text-sm sm:leading-6">
    </div>

    <ul class="text-secondary-text">
        <li class="flex items-center ps-3">
            <input type="checkbox" bind:checked={guidedMode} id="guidedmode" class="rounded text-accent-highlight bg-gray-100 border-gray-300 focus:ring-accent-border">
            <label for="guidedmode" class="py-1 ms-2">Geführter Modus (Ergebnisse sind nicht direkt einsehbar)</label>
        </li>

        <li class="flex items-center ps-3">
            <input type="checkbox" bind:checked={ausbildungenOnly} id="ausbildungenOnly" class="rounded text-accent-highlight bg-gray-100 border-gray-300 focus:ring-accent-border">
            <label for="ausbildungenOnly" class="py-1 ms-2">Nur Ausbildungen</label>
        </li>
    </ul>

    <Button on:click={generateUsers} className="w-full rounded-md" variant="submit">Nutzer generieren</Button>

    {#if loading}
        <div class="loading-spinner"></div>
    {/if}

    {#if users.length > 0}
        <div class="mt-4">
            <p>Die folgenden Nutzer wurden erfolgreich registriert:</p>
            <ul>
                {#each users as user}
                    <li>{user.name} - {user.authcode}</li>
                {/each}
            </ul>
        </div>
        <Button on:click={exportUsersAsWord} className="w-full rounded-md mt-4" variant="submit">Als Word-Dokument herunterladen</Button>
    {/if}
    </ContentBox>

    <div class="flex mx-4 mb-2 justify-between w-1/3" style="min-width: 300px">
        <Button variant="default" on:click={pop}>
            <div class="flex gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-move-left"><path d="M6 8L2 12L6 16"/><path d="M2 12H22"/></svg>
                <p>Zurück zum Adminbereich</p>
            </div>
        </Button>   
    </div>

</PageBox>

<style>
    .loading-spinner {
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-left-color: #f59e0b;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 1s linear infinite;
        margin: 20px auto;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
</style>
